import React from 'react'
import injectStyles from 'react-jss'

import { QUIZ_QUESTION_TYPES } from '../../../../shared/constants'
import { Typography } from '@material-ui/core'
import styles from '../QuizQuestionItem/styles'
import { Input } from '../../../Form/Input/index'
import TrashCanV2 from '../../../../Assets/Images/icons/trashCanV2'
import RoundRadioButton from '../../../../Assets/Images/icons/roundRadioButton'
import SquareCheckBox from '../../../../Assets/Images/icons/squareCheckBox'

const QuizQuestionOption = ({
  index,
  type,
  onOptionChange,
  onDeleteOption,
  onChangeCorrectAnswer,
  isCorrectAnswer,
  onAddOption,
  value,
  classes,
  isDisabled,
}) => {
  const {
    item,
    input,
    checkBoxContainer,
    inputWithUnderline,
    questionCheckBox,
  } = classes

  const handleKeyPress = event => {
    const keyCode = event.which || event.keyCode
    if (keyCode === 13 || keyCode === 38) {
      onAddOption()
    }
  }

  return (
    <div className={item}>
      {isDisabled ? (
        <Typography className={input}>{value}</Typography>
      ) : (
        <Input
          onChange={e => onOptionChange({ text: e.target.value })}
          onKeyPressCapture={handleKeyPress}
          className={inputWithUnderline}
          type="text"
          placeholder="Option"
          value={value}
          inputClassName={inputWithUnderline}
        />
      )}

      <div className={questionCheckBox}>
        <div
          className={checkBoxContainer}
          onClick={() => onChangeCorrectAnswer()}
        >
          {type === QUIZ_QUESTION_TYPES.SINGLE_CHOICE ? (
            <RoundRadioButton active={isCorrectAnswer} />
          ) : (
            <SquareCheckBox active={isCorrectAnswer} />
          )}
        </div>
        <div className={classes.button} onClick={onDeleteOption}>
          <TrashCanV2 />
        </div>
      </div>
    </div>
  )
}

export default injectStyles(styles)(QuizQuestionOption)
